const Spinner = ({ show }) => {
    if (!show) return null;
    return (
        <div className="fullscreen-mask">
            <div className="spinner-container">
                <div className="spinner" />
                <p>Logging in. Please wait...</p>
            </div>
        </div>
    );
};

export default Spinner;